import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Box, useColorModeValue, useToast } from "@chakra-ui/react";
import { AuthContext } from "../store/auth-context";
import { GetLikesNotifications } from "../services/backend";
import LikesCountBar, { LIKES_BAR_HEIGHT } from "./LikesCountBar";
import { usePremiumAccess } from "../hooks/usePremiumAccess";

function BarSkeleton() {
  const sk = useColorModeValue("gray.100", "whiteAlpha.100");
  return <Box w="100%" h={LIKES_BAR_HEIGHT} borderRadius="2xl" bg={sk} opacity={0.4} />;
}

export default function HomeLikesSection({ onUpgrade }) {
  const { t } = useTranslation();
  const AuthCtx = useContext(AuthContext);
  const toast = useToast();
  const { isPremium } = usePremiumAccess();
  const user = AuthCtx.authenticatedUser;

  const [likesNotifications, setLikesNotifications] = useState();

  const hasValidSubscription = isPremium === true;

  useEffect(() => {
    async function fetchLikes() {
      if (!user?.id) return;
      try {
        const likes = await GetLikesNotifications(user.id);
        setLikesNotifications(likes);
      } catch (error) {
        toast({
          position: "bottom-left",
          title: t("likes.fetchFailed"),
          description: error.message || t("likes.fetchFailedDescription"),
          status: "error",
          duration: 15000,
          isClosable: true,
        });
      }
    }
    fetchLikes();
  }, [toast, user?.id, t]);

  const hasLikes = Array.isArray(likesNotifications) && likesNotifications.length > 0;
  const isLoading = likesNotifications === undefined;

  if (!isLoading && !hasLikes) {
    return null;
  }

  if (isLoading) {
    return <BarSkeleton />;
  }

  return (
    <Box mb={{ base: 3, md: 5 }}>
      <LikesCountBar
        likesNotifications={likesNotifications}
        blurred={!hasValidSubscription}
        onUpgrade={onUpgrade}
        showClearHint
      />
    </Box>
  );
}
